export const getWorkingDaysInMonth = (date) => {
  const year = date.getFullYear();
  const month = date.getMonth();
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  let workingDaysCount = 0;

  const publicHolidays = [
    '01-01', '01-06', '05-01', '05-03', '08-15', 
    '11-01', '11-11', '12-24', '12-25', '12-26'
  ];

  const getMovableHolidays = (year) => {
    const a = year % 19;
    const b = Math.floor(year / 100);
    const c = year % 100;
    const d = Math.floor(b / 4);
    const e = b % 4;
    const f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3);
    const h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4);
    const k = c % 4;
    const l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451);
    const easterMonth = Math.floor((h + l - 7 * m + 114) / 31);
    const easterDay = ((h + l - 7 * m + 114) % 31) + 1;
    const easter = new Date(year, easterMonth - 1, easterDay);

    const easterMonday = new Date(easter);
    easterMonday.setDate(easter.getDate() + 1);

    const pentecost = new Date(easter);
    pentecost.setDate(easter.getDate() + 49); // Zielone Świątki

    const corpusChristi = new Date(easter);
    corpusChristi.setDate(easter.getDate() + 60); // Boże Ciało

    const format = (d) =>
      `${(d.getMonth() + 1).toString().padStart(2, '0')}-${d.getDate().toString().padStart(2, '0')}`;
    
    return [format(easterMonday), format(pentecost), format(corpusChristi)];
  };

  const movableHolidays = getMovableHolidays(year);
  const allHolidays = [...publicHolidays, ...movableHolidays];

  for (let day = 1; day <= daysInMonth; day++) {
    const currentDay = new Date(year, month, day);
    const dayOfWeek = currentDay.getDay(); // 0 = Niedziela, 6 = Sobota
    
    const isWeekend = dayOfWeek === 0 || dayOfWeek === 6;
    const monthDay = `${(month + 1).toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
    const isHoliday = allHolidays.includes(monthDay);

    // Dzień roboczy to taki, który nie jest weekendem I nie jest świętem
    if (!isWeekend && !isHoliday) {
      workingDaysCount++;
    }
  }

  return workingDaysCount;
};